import { aiOpenapiClient, unwrapResult } from '@/api/openapi-client';
import { summarizeChecklist } from '@/features/menu/utils/menu-checklist';
import { useRestaurantStore } from '@/stores/restaurant.store';
import type { MenuChecklist } from '@restaurant/api-client';
import { useQuery } from '@tanstack/react-query';

export function useMenuChecklist(menuId: string) {
  const restaurantId = useRestaurantStore((s) => s.selectedRestaurantId) ?? '';
  return useQuery({
    queryKey: ['menu', 'checklist', restaurantId, menuId],
    enabled: !!restaurantId,
    queryFn: async () =>
      unwrapResult<MenuChecklist>(
        await aiOpenapiClient.GET('/restaurants/{restaurantId}/ai/menus/{menuId}/checklist', {
          params: { path: { restaurantId, menuId } },
        }),
      ),
    select: summarizeChecklist,
  });
}
